module.exports = __webpack_public_path__ + "img/lithuania.83502de2.png";